import { render, staticRenderFns } from "./bulk-message-template-type-cards.vue?vue&type=template&id=07c3a180&scoped=true&"
import script from "./bulk-message-template-type-cards.vue?vue&type=script&lang=js&"
export * from "./bulk-message-template-type-cards.vue?vue&type=script&lang=js&"
import style0 from "./bulk-message-template-type-cards.vue?vue&type=style&index=0&id=07c3a180&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c3a180",
  null
  
)

export default component.exports